import {
  Medication,
  MedicationCreateRequest,
  MedicationCreateResponse,
  MedicationGetAllParams,
  MedicationGetAllResponse,
  MedicationQueryParams,
} from '@quromedical/models';
import { compact } from '@quromedical/utils';
import { trpc } from 'trpc';

export class MedicationApi {
  /**
   * Get an SWR Key associated with the `getMedications` function.
   */
  public getMedicationSWRKey = (
    patientId: string,
    status?: fhir4.MedicationStatement['status']
  ): string => compact([patientId, status]).join('/');

  public searchMedication = async (params: MedicationGetAllParams): Promise<Medication[]> => {
    const result = await trpc.client.medication.search.query(params);

    return result;
  };

  public async getMedicationStatements(
    params: MedicationQueryParams
  ): Promise<MedicationGetAllResponse> {
    const result = await trpc.client.medicationStatement.getAll.query(params);

    return result;
  }

  public async createMedication(
    params: MedicationCreateRequest
  ): Promise<MedicationCreateResponse> {
    const result = await trpc.client.medicationStatement.create.mutate(params);

    return result;
  }
}
